/* eslint no-console: 0 */
import { mount } from 'svelte';
import RedirectsEditor from '../svelte/redirects_editor.svelte'

document.addEventListener('turbo:load', () => {
  function parseRedirects(){
    let raw = document.getElementById('site_redirects').value;
    let parsed = [];
    try{parsed = JSON.parse(raw)}catch(e){}
    return parsed.constructor == Array ? parsed : [parsed];
  }

  const editor = document.getElementById('redirects-editor');
  if(editor){
    const redirectsEditor = mount(RedirectsEditor, {
      target: editor,
      props: {
        parsedRedirects: parseRedirects(),
        outputTo: document.getElementById('site_redirects')
      }
    });

    window.redirectsEditor = redirectsEditor;
  }
})

